// frontend/src/components/EdaAnalysis/EdaAnalysis.tsx

import React, { useEffect } from 'react';
import { useEda } from '../../hooks/useEda';
import { useAuth } from '../../contexts/AuthContext';
import { EdaSelector } from './EdaSelector';
import { EdaDatasetStats } from './EdaDatasetStats';
import { EdaTargetDistribution } from './EdaTargetDistribution';
import { EdaSeparability } from './EdaSeparability';
import { EdaWarnings } from './EdaWarnings';
import './EdaAnalysis.css';

export const EdaAnalysis: React.FC = () => {
  const { selectedTraceId, selectedDataset: authDatasetName } = useAuth();
  
  const {
    snapshots,
    selectedSnapshot,
    analysis,
    loading,
    error,
    selectSnapshot,
    listSnapshots,
  } = useEda();

  useEffect(() => {
    listSnapshots();
  }, [listSnapshots]);

  if (loading && !analysis) {
    return (
      <div className="eda-container">
        <div className="loading-state">🔬 Carregando análise EDA...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="eda-container">
        <div className="error-state">❌ {error}</div>
      </div>
    );
  }

  // Se há trace selecionado globalmente mas a análise ainda não chegou
  if (selectedTraceId && !analysis) {
    return (
      <div className="eda-container">
        <div className="loading-state">⏳ Carregando dados do dataset selecionado...</div>
      </div>
    );
  }

  return (
    <div className="eda-container">
      <div className="eda-header">
        <h1>🔬 Análise Exploratória de Dados (EDA)</h1>
        <p className="subtitle">Diagnóstico científico do dataset para modelagem</p>

        {selectedSnapshot?.trace_id && (
          <div className="trace-badge">
            <span className="label">Trace ID:</span>
            <code>{selectedSnapshot.trace_id}</code>
          </div>
        )}
      </div>

      {/* Só exibe o seletor se NÃO houver trace selecionado globalmente */}
      {!selectedTraceId ? (
        <EdaSelector
          snapshots={snapshots}
          selectedSnapshot={selectedSnapshot}
          onSelect={selectSnapshot}
          loading={loading}
        />
      ) : (
        <div style={{
          background: 'rgba(79, 195, 247, 0.1)',
          border: '1px solid #4fc3f7',
          borderRadius: '8px',
          padding: '12px 16px',
          marginBottom: '24px',
          color: '#4fc3f7',
        }}>
          <span>
            Dataset em foco: <strong>{analysis?.dataset_name || selectedSnapshot?.dataset_name || authDatasetName || 'Carregando...'}</strong>
          </span>
          <div style={{ fontSize: '11px', marginTop: '4px', color: '#8899aa' }}>
            Para alterar o dataset, acesse a tela "Meus Dados".
          </div>
        </div>
      )}

      {analysis && (
        <>
          <EdaDatasetStats analysis={analysis} />
          <EdaTargetDistribution analysis={analysis} />
          <EdaSeparability analysis={analysis} />
          <EdaWarnings warnings={analysis.warnings} />
          {/* EdaFeatureImportance removido */}
        </>
      )}
    </div>
  );
};

export default EdaAnalysis;